// @flow
import * as React from 'react';

import type { User } from '../types/User';

// This is only used when rendering a Consumer without a Provider above it
const defaultValue: User = {
  id: '',
  type: 'user',
  name: '',
  email: '',
  language: '',
  accountHost: '',
};

const { Consumer, Provider } = React.createContext<User>(defaultValue);

const withCurrentUser = (UserComp: React.ComponentType<any>) => (
  props: any,
) => (
  <Consumer>
    {currentUser => <UserComp currentUser={currentUser} {...props} />}
  </Consumer>
);

export { Provider, Consumer, defaultValue, withCurrentUser };
